import React from 'react';
import { InputFormField } from '@ui/Form/Fields';
import { Translate, I18n } from 'react-redux-i18n';
import Button from '@ui/Button';
import styles from './styles.module.scss';

const Form = () => {
  return (
    <>
      <InputFormField name="email" placeholder={I18n.t('placeholder.email')} />
      <InputFormField
        type="password"
        name="password"
        placeholder={I18n.t('placeholder.password')}
      />
      <InputFormField
        name="realName"
        placeholder={I18n.t('placeholder.name')}
      />
      <InputFormField name="phone" placeholder={I18n.t('placeholder.phone')} />

      <Button className={styles.submitButton} type="submit" color="green">
        <Translate value="auth.signup" />
      </Button>
    </>
  );
};

export default Form;
